var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-card',{staticClass:"pa-2 mr-1"},[_vm._v(" "+_vm._s(_vm.hour)+" ")]),_c('v-card',{staticClass:"pa-2 mr-1"},[_vm._v(" "+_vm._s(_vm.min)+" ")]),_c('v-card',{staticClass:"pa-2 mr-1"},[_vm._v(" "+_vm._s(_vm.sec)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }